import React, { useState } from 'react';
import { Modal, TextField, Button, Box } from '@mui/material';
import { useAddTaskMutation, useUpdateTaskMutation } from './redux/fullApi';

const TaskModal = ({ isOpen, handleClose, operation, task }) => {
  const [title, setTitle] = useState(task?.name ?? '');

  const handleInputChange = (e) => {
    setTitle(e.target.value);
  };

  const [addTask] = useAddTaskMutation()
  const [updateTask] = useUpdateTaskMutation()

  const handleSubmit = (e) => {
    e.preventDefault()
    if(operation === 'create') {
      addTask({name: title, completed: "false"})
      .then(res => {
      setTitle('');
      })
      .catch((e) => {
        console.log("ERROR ON CREATING TASK", e)
      })
    } else if(operation === 'update') {
      updateTask({id: task.id, name: title, completed: task.completed}, {id: task.id}).then(res => {
      }).catch((e) => {
        console.log("ERROR ON UPDATING TASK", e)
      })
    }

    handleClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 300, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
        <h2 id="modal-title" style={{color:'#000'}}>Add new task</h2>
         <form onSubmit={handleSubmit}> {/* Use a form element */}
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 300, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
          <h2 id="modal-title" style={{ color: '#000' }}>{operation==='create' ? <span>Add new task</span> : <span>Edit task</span>}</h2>
          <TextField
            fullWidth
            id="title"
            label="Title"
            variant="outlined"
            value={title}
            onChange={handleInputChange}
            margin="normal"
          />
          <Button type="submit" variant="contained" sx={{ mt: 2 }}> {/* Use type="submit" for the button */}
            Save
          </Button>
        </Box>
      </form>
      </Box>
    </Modal>
  );
};

export default TaskModal;
